import React, { useState, useMemo } from 'react';
import { api } from '../lib/api';

export interface WellFormProps {
  initialWell?: any;
  onSaved: () => void;
}

const WellForm: React.FC<WellFormProps> = ({ initialWell, onSaved }) => {
  const [uwi, setUwi] = useState(initialWell?.uwi || '');
  const [lease, setLease] = useState(initialWell?.lease || '');
  const [wellNumber, setWellNumber] = useState(initialWell?.wellNumber || '');
  const [status, setStatus] = useState(initialWell?.status || '');
  const [wellType, setWellType] = useState(initialWell?.wellType || '');
  const [county, setCounty] = useState(initialWell?.county || '');
  const [state, setState] = useState(initialWell?.state || '');
  const [country, setCountry] = useState(initialWell?.country || '');
  const [company, setCompany] = useState(initialWell?.company || '');
  const [error, setError] = useState<string | null>(null);

  const name = useMemo(() => `${lease} ${wellNumber}`.trim(), [lease, wellNumber]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!uwi || !lease || !wellNumber || !status || !wellType || !county || !state || !country || !company) {
      setError('All fields are required');
      return;
    }
    setError(null);
    try {
      const payload = { uwi, lease, wellNumber, status, wellType, county, state, country, company };
      if (initialWell?.id) {
        await api.wells.update(initialWell.id, payload);
      } else {
        await api.wells.create(payload);
      }
      onSaved();
    } catch (err) {
      setError('Failed to save well');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="uwi" className="block text-sm text-gray-300">UWI</label>
        <input id="uwi" value={uwi} onChange={e => setUwi(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label htmlFor="lease" className="block text-sm text-gray-300">Lease</label>
          <input id="lease" value={lease} onChange={e => setLease(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
        <div>
          <label htmlFor="wellNumber" className="block text-sm text-gray-300">Well Number</label>
          <input id="wellNumber" value={wellNumber} onChange={e => setWellNumber(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
      </div>
      <p className="text-sm text-gray-400">Name: <span data-testid="name-preview">{name}</span></p>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label htmlFor="status" className="block text-sm text-gray-300">Status</label>
          <input id="status" value={status} onChange={e => setStatus(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
        <div>
          <label htmlFor="wellType" className="block text-sm text-gray-300">Well Type</label>
          <input id="wellType" value={wellType} onChange={e => setWellType(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <label htmlFor="county" className="block text-sm text-gray-300">County</label>
          <input id="county" value={county} onChange={e => setCounty(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
        <div>
          <label htmlFor="state" className="block text-sm text-gray-300">State</label>
          <input id="state" value={state} onChange={e => setState(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
        <div>
          <label htmlFor="country" className="block text-sm text-gray-300">Country</label>
          <input id="country" value={country} onChange={e => setCountry(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
        </div>
      </div>
      <div>
        <label htmlFor="company" className="block text-sm text-gray-300">Company</label>
        <input id="company" value={company} onChange={e => setCompany(e.target.value)} className="w-full p-2 rounded bg-gray-800 text-white" required />
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <div className="flex justify-end space-x-2">
        <button type="submit" className="px-4 py-2 bg-white text-black rounded">Save</button>
      </div>
    </form>
  );
};

export default WellForm;
